export function joinErrorMessage(status: number, serverError?: string): string {
  switch (status) {
    case 401:
      return 'Для входа в эту комнату требуется авторизация';
    case 403:
      return 'Неверный ключ шифрования';
    case 404:
      return 'Комната не найдена или встреча ещё не началась';
    case 410:
      return 'Встреча отменена';
    default:
      return serverError || 'Не удалось войти в комнату';
  }
}
